// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/transfer_inventory_request.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { TransferRequestItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.TransferInventoryRequestRequest
 */
export class TransferInventoryRequestRequest extends Message<TransferInventoryRequestRequest> {
  /**
   * The ID of the stock point from which to transfer inventory
   *
   * @generated from field: string source_stock_point_id = 1;
   */
  sourceStockPointId = "";

  /**
   * The ID of the stock point to which to transfer inventory
   *
   * @generated from field: string destination_stock_point_id = 2;
   */
  destinationStockPointId = "";

  /**
   * The list of inventory items to transfer
   *
   * @generated from field: repeated com.neulink.pharmacy.TransferRequestItem items = 3;
   */
  items: TransferRequestItem[] = [];

  /**
   * Optional notes regarding the transfer
   *
   * @generated from field: string transfer_notes = 4;
   */
  transferNotes = "";

  /**
   * @generated from field: string source_branch_code = 5;
   */
  sourceBranchCode = "";

  /**
   * @generated from field: string destination_branch_code = 6;
   */
  destinationBranchCode = "";

  /**
   * @generated from field: string source_branch_name = 7;
   */
  sourceBranchName = "";

  /**
   * @generated from field: string destination_branch_name = 8;
   */
  destinationBranchName = "";

  constructor(data?: PartialMessage<TransferInventoryRequestRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferInventoryRequestRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source_stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "destination_stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "items", kind: "message", T: TransferRequestItem, repeated: true },
    { no: 4, name: "transfer_notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source_branch_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "destination_branch_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "source_branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "destination_branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferInventoryRequestRequest {
    return new TransferInventoryRequestRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferInventoryRequestRequest {
    return new TransferInventoryRequestRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferInventoryRequestRequest {
    return new TransferInventoryRequestRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TransferInventoryRequestRequest | PlainMessage<TransferInventoryRequestRequest> | undefined, b: TransferInventoryRequestRequest | PlainMessage<TransferInventoryRequestRequest> | undefined): boolean {
    return proto3.util.equals(TransferInventoryRequestRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TransferInventoryRequestResponse
 */
export class TransferInventoryRequestResponse extends Message<TransferInventoryRequestResponse> {
  /**
   * Unique identifier for the transfer operation
   *
   * @generated from field: string transfer_request_id = 1;
   */
  transferRequestId = "";

  /**
   * Optional purchase request ID if the transfer is linked to a purchase request
   *
   * @generated from field: string purchase_request_id = 2;
   */
  purchaseRequestId = "";

  /**
   * Optional purchase request number if the transfer is linked to a purchase request
   *
   * @generated from field: string pr_number = 3;
   */
  prNumber = "";

  /**
   * Unique identifier for the transfer operation
   *
   * @generated from field: string transfer_number = 4;
   */
  transferNumber = "";

  constructor(data?: PartialMessage<TransferInventoryRequestResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferInventoryRequestResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transfer_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "purchase_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pr_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transfer_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferInventoryRequestResponse {
    return new TransferInventoryRequestResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferInventoryRequestResponse {
    return new TransferInventoryRequestResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferInventoryRequestResponse {
    return new TransferInventoryRequestResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TransferInventoryRequestResponse | PlainMessage<TransferInventoryRequestResponse> | undefined, b: TransferInventoryRequestResponse | PlainMessage<TransferInventoryRequestResponse> | undefined): boolean {
    return proto3.util.equals(TransferInventoryRequestResponse, a, b);
  }
}

